import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import Back from "../../../assets/svg/backarrow.svg";
import { getGroupDetailsApi, getMasterDetailsApi, saveMasterApi, UpdateMasterApi } from "./template-api";
import DOMPurify from "dompurify";

const TemplateAdd = () => {
  const navigate = useNavigate();
  const apiAccUrl = process.env.REACT_APP_ADMIN_API_URL;
  const location = useLocation();
  const id = location.state?.id;

  //Inputs
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [validations, setValidations] = useState({
    code: "",
    name: "",
    medium: "",
    template: "",
  });

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [contentValue, setContentValue] = useState("");

  const fullToolbar = {
    toolbar: [[{ font: [] }], [{ size: ["small", false, "large", "huge"] }], ["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], ["image", "video"], ["link", "code-block"], [{ align: [] }], [{ list: "ordered" }, { list: "bullet" }], [{ indent: "-1" }, { indent: "+1" }], [{ direction: "rtl" }], [{ header: 1 }, { header: 2 }], ["clean"]],
  };

  const formats = ["header", "font", "size", "bold", "italic", "underline", "strike", "color", "background", "link", "image", "video", "code-block", "list", "bullet", "align", "indent", "direction"];

  //Master Save

  const submitCall = async () => {
    const dataBeforeSanitize = {
      code: code ?? "",
      name: name ?? "",
      medium: type ?? "",
      template: contentValue ?? "",
    };

    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });

    let response;
    if (id != null) {
      response = await UpdateMasterApi(dataAfterSanitize, id);
    } else {
      response = await saveMasterApi(dataAfterSanitize);
    }

    if (response.status === 200) {
      if (response.data.success === true) {
        navigate("/masters/template");
      }
    }
    if (response.status === 400) {
      new Promise((resolve, reject) => {
        const validationTemp = {
          name: "",
          code: "",
          medium: "",
          template: "",
        };

        Object.entries(response.data.error).forEach(([key, value]) => {
          const baseKey = key.includes(".") ? key.split(".")[0] : key;
          if (baseKey in validationTemp) {
            validationTemp[baseKey] = Array.isArray(value) && value.length > 0 ? value[0] : "";
          }
        });
        setValidations(validationTemp);
      });
    }
  };

  //Master Edit
  const getMasterDetails = async () => {
    try {
      const response = await getMasterDetailsApi(id);
      console.log("master", response);

      if (response.success === true && response.template) {
        const master = response.template;
        console.log(master);
        setType(master.medium ?? "");
        setName(master.name ?? "");
        setCode(master.code ?? "");
        setContentValue(master.template ?? "");
      }
    } catch (err) {
      console.error("Error fetching master details:", err);
    }
  };

  useEffect(() => {
    if (id != null) {
      getMasterDetails();
    }
  }, [id]);



  return (
    <div style={{ fontFamily: "Lexend Deca", width: "100%", height: "100%", backgroundColor: "#F0F4F9", padding: "16px" }}>
      <Row style={{ marginBottom: "24px" }}>
        <Col sm={2} lg={8}>
          <div>
            <img onClick={() => navigate(-1)} style={{ height: "40px", cursor: "pointer" }} src={Back} alt="Back" />
          </div>
        </Col>
        <Col sm={10} lg={4}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", justifyContent: "flex-end" }}>
            <button onClick={() => navigate(-1)} style={{ height: "40px", lineHeight: "100%", borderRadius: "100px", border: "1px solid #d4dde7", padding: "10px 28px", fontWeight: "600", fontSize: "15px", color: "#172b4d", backgroundColor: "#ffffff" }}>
              Cancel
            </button>
            <button onClick={submitCall} style={{ height: "40px", borderRadius: "100px", border: "1px solid #d4dde7", padding: "10px 28px", fontWeight: "600", fontSize: "15px", color: "#ffffff", backgroundColor: "#3B84E6", lineHeight: "100%" }}>
              Save
            </button>
          </div>
        </Col>
      </Row>

      <Row style={{ marginBottom: "24px" }}>
        <Col sm={12}>
          <div style={{ borderRadius: "24px", padding: "24px", backgroundColor: "#ffffff" }}>
            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12}>
                <div style={{ fontWeight: "500", fontSize: "18px", color: "#172b4d" }}>Template details</div>
              </Col>
            </Row>

            <Row style={{ marginBottom: "24px" }}>
              <Col sm={12} md={4} className="mb-3">
                <div style={{ fontSize: "13px", color: "#172b4d", fontWeight: "500", marginBottom: "8px" }}>Name</div>
                <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="Enter name" style={{ fontSize: "14px", height: "40px", borderRadius: "10px", border: "1.5px solid #ebebeb", padding: "8px 12px", width: "100%" }} />
                <span style={{fontWeight:'300',fontSize:'12px',color:'#ff4444'}}>{validations.name}</span>
              </Col>

              <Col sm={12} md={4} className="mb-3">
                <div style={{ fontSize: "13px", color: "#172b4d", fontWeight: "500", marginBottom: "8px" }}>Code</div>
                <input value={code} onChange={(e) => setCode(e.target.value)} type="text" placeholder="Enter code" style={{ fontSize: "14px", height: "40px", borderRadius: "10px", border: "1.5px solid #ebebeb", padding: "8px 12px", width: "100%" }} />
                <span style={{fontWeight:'300',fontSize:'12px',color:'#ff4444'}}>{validations.code}</span>
              </Col>

              <Col sm={12} md={4}>
                <div style={{ fontSize: "13px", color: "#172b4d", fontWeight: "500", marginBottom: "8px" }}>Type</div>
                <div>
                  <select value={type} onChange={(e) => setType(e.target.value)} style={{ height: "40px", borderRadius: "10px", border: "1.5px solid #ebebeb", padding: "0px 12px", backgroundColor: "#ffffff", fontWeight: "300", fontSize: "13px", color: "#172b4d", width: "100%" }}>
                    <option>Select</option>
                    <option value="email">Email</option>
                    <option value="sms">SMS</option>
                    <option value="app-notification">Notification</option>
                  </select>
                  <span style={{fontWeight:'300',fontSize:'12px',color:'#ff4444'}}>{validations.medium}</span>
                </div>

              </Col>
            </Row>

            <Row>
              <Col xs={12} style={{ marginTop: "0.5rem" }}>
                <div style={{marginBottom: "0.5rem"}}>
                  <div style={{ fontSize: "13px", fontWeight: "500", color: "#172b4d" }}>Content </div>
                <span style={{fontWeight:'300',fontSize:'12px',color:'#ff4444'}}>{validations.template}</span>
                </div>
                
                <>
                  <style>{`.ql-container{border:none!important;}.ql-editor{padding:16px!important;}`}</style>
                  <ReactQuill theme="snow" value={contentValue} onChange={setContentValue} modules={fullToolbar} formats={formats} style={{ backgroundColor: "#ffffff", borderRadius: "10px", border: "1px solid #e0e0e0", fontSize: "14px", minHeight: "300px" }} />
                </>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TemplateAdd;
